import { px2rem } from "@moim/common";
import styled, { css } from "styled-components";

export const Container = styled.div<{ $uploading: boolean }>`
  max-width: ${px2rem(520)};
  width: 100%;
  height: fit-content;
  max-height: 50dvh;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: white;
  border-radius: ${px2rem(8)};
  box-shadow: 0 ${px2rem(4)} ${px2rem(16)} rgba(0, 0, 0, 0.1);
  padding: ${px2rem(24)} ${px2rem(20)};

  * {
    color: black;
  }

  ::after {
    position: absolute;
    inset: 0;
    z-index: 1;
    content: "loading...";
    display: ${({ $uploading }) => ($uploading ? "flex" : "none")};
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 80%);
    user-select: none;
  }
`;

export const Welcome = styled.div`
  margin-bottom: ${px2rem(8)};
  .title {
    font-weight: bold;
    font-size: ${px2rem(28)};
    line-height: 1.6;
  }

  .subTitle {
    font-size: ${px2rem(20)};
    line-height: 1.2;
  }
`;

export const FloatHeader = styled.div<{ $show: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: ${px2rem(40)};
  background-color: rgba(0, 0, 0, 0.4);

  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 ${px2rem(20)};

  button {
    color: white;
    width: fit-content;
    height: ${px2rem(32)};
    padding: 0 ${px2rem(8)};
    font-size: ${px2rem(16)};
    font-weight: bold;
    :hover {
      text-decoration: underline;
    }
  }

  transition-property: opacity, transform;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  visibility: hidden;
  opacity: 0;
  transform: translateY(-100%);

  ${({ $show }) =>
    $show &&
    css`
      visibility: visible;
      opacity: 1;
      transform: translateY(0);
    `}
`;

export const GridWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${px2rem(4)};
`;

export const Item = styled.div<{ $selected: boolean; $teamColor?: string }>`
  width: 100%;
  padding: ${px2rem(4)} ${px2rem(8)};
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${px2rem(4)};
  justify-content: center;
  border-radius: ${px2rem(8)};
  border: ${px2rem(4)} solid
    ${({ $selected, theme }) => ($selected ? theme.color.red : "#d2d2d2")};
  user-select: none;

  img {
    width: ${px2rem(80)};
    height: ${px2rem(80)};
  }

  .logoBox {
    width: ${px2rem(80)};
    height: ${px2rem(80)};
    line-height: ${px2rem(80)};
    text-align: center;
    font-size: ${px2rem(42)};
    font-weight: bold;
    border-radius: ${px2rem(4)};
  }

  .name {
    font-size: ${px2rem(22)};
    line-height: 1.2;
    font-weight: bold;
    text-align: center;
  }
`;
